import request from 'request';

import {
  Firebase,
  callIfFunction,
  appConfig,
} from '../../util';

//Not action creator
export function authorizeIntegration(integrationType, code, callback){
  Firebase.auth().currentUser.getIdToken().then(authToken => {

    request({
      method: 'POST',
      uri: `${appConfig().API_URL}/authorizeIntegration`,
      body: {
        integrationType,
        code,
      },
      json: true,
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }, (err, resp, body) => {
      callIfFunction(callback, err);
    }).catch(err => {
      callIfFunction(callback, err);
    });

  }).catch(err => {
    callIfFunction(callback, err);
  });
}

export function deactivateIntegration(integrationType, callback){
  Firebase.auth().currentUser.getIdToken().then(authToken => {

    request({
      method: 'POST',
      uri: `${appConfig().API_URL}/deactivateIntegration`,
      body: {
        integrationType,
      },
      json: true,
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }, (err, resp, body) => {
      callIfFunction(callback, err);
    }).catch(err => {
      callIfFunction(callback, err);
    });
  }).catch(err => {
    callIfFunction(callback, err);
  });
}



// WEBPACK FOOTER //
// ./src/actions/integrations/index.js